export const CONFIRMING_CANDIDATE_INTEREST = "TO REVIEW";
export const CANDIDATE_INTERESTED = "ACCEPTED";
export const CANDIDATE_NOT_INTERESTED = "PASSED";
export const INTRODUCED = "INTRODUCED";



// WEBPACK FOOTER //
// ./src/constants/introPriorities.js